var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.75C3.54812 0.75 0.75 3.54812 0.75 7C0.75 10.4519 3.54812 13.25 7 13.25C10.4519 13.25 13.25 10.4519 13.25 7C13.25 3.54812 10.4519 0.75 7 0.75ZM9.4875 6.375C9.4225 4.74219 9.10531 3.29812 8.63562 2.28031C10.4009 2.89406 11.7172 4.46719 11.9566 6.375H9.4875ZM7 11.9687C6.62094 11.6703 5.8725 10.1762 5.76437 7.625H8.23562C8.1275 10.1762 7.37906 11.6703 7 11.9687ZM5.76437 6.375C5.8725 3.82375 6.62094 2.32969 7 2.03125C7.37906 2.32969 8.1275 3.82375 8.23562 6.375H5.76437ZM5.36437 2.28031C4.895 3.29812 4.5775 4.74219 4.5125 6.375H2.04344C2.28281 4.4675 3.59906 2.89406 5.36437 2.28031ZM4.5125 7.625C4.5775 9.25781 4.89469 10.7019 5.36437 11.7197C3.59906 11.1059 2.28281 9.5325 2.04344 7.625H4.5125ZM8.63562 11.7197C9.105 10.7019 9.4225 9.25781 9.4875 7.625H11.9569C11.7172 9.5325 10.4009 11.1059 8.63562 11.7197Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon);
export default __webpack_public_path__ + "static/media/WorldIcon.1de4d2a7b53fb086bcb304cc821c87e2.svg";
export { ForwardRef as ReactComponent };